import { ReactNode } from 'react';
import { Link as WouterLink } from 'wouter';

interface CustomLinkProps {
  href: string;
  children: ReactNode;
  className?: string;
  onClick?: () => void;
}

export default function CustomLink({ 
  href, 
  children, 
  className,
  onClick
}: CustomLinkProps) {
  const handleClick = (event: React.MouseEvent) => {
    // Execute any additional onClick handlers
    if (onClick) onClick();
    
    // Scroll to the top of the page
    window.scrollTo(0, 0);
  };

  return (
    <WouterLink href={href}>
      <div 
        className={className} 
        onClick={handleClick}
      >
        {children}
      </div>
    </WouterLink>
  );
} 